import { createReducer } from 'redux-create-reducer';

import {
  CHANGE_CLIENT_PROFILE_ENTRY_STATUS,
  CLEAR_CLIENT_PROFILE_ENTRY_STATUS,
} from '../types';

const initialState = {
  data: {},
  isLoading: false,
};

const changeClientProfileEntryStatusReducer = createReducer(initialState, {
  [CHANGE_CLIENT_PROFILE_ENTRY_STATUS.DEFAULT]: state => ({
    ...state,
    isLoading: false,
  }),
  [CHANGE_CLIENT_PROFILE_ENTRY_STATUS.PENDING]: state => ({
    ...state,
    isLoading: true,
  }),
  [CHANGE_CLIENT_PROFILE_ENTRY_STATUS.REJECTED]: state => ({
    ...state,
    isLoading: false,
  }),
  [CHANGE_CLIENT_PROFILE_ENTRY_STATUS.FULFILLED]: (state, { payload }) => ({
    ...state,
    data: payload.data,
    isLoading: false,
  }),
  [CLEAR_CLIENT_PROFILE_ENTRY_STATUS]: () => initialState,
});


export default changeClientProfileEntryStatusReducer;


// WEBPACK FOOTER //
// ./src/features/client-profile/reducers/changeClientProfileEntryStatusReducer.js